import { ContainerWrapper } from '../Container'
import SectionHeading from '../HomePage/SectionHeading'

export default function CaseStudyCard({
    study: { title, description, client, image, imageAlt, imageTitle },
    alignment,
    bg = 'bg-transparent',
    size = 'xl',
}) {
    const alignmentClass =
        alignment === 'left' ? 'order-last lg:ml-10' : 'lg:mr-10'

    const shouldAddPadding = bg == 'bg-transparent' ? false : true
    return (
        <div className={`${bg} rounded-8xl md:rounded-8xl`}>
            <ContainerWrapper>
                <div
                    className={`${shouldAddPadding && 'pb-12 md:py-16'}
                    ${size === 'xl' ? 'md:max-w-5xl m-auto' : 'md:max-w-full'}
                    px-4 md:px-0 lg:flex lg:items-center lg:justify-between space-y-10 lg:space-y-0`}>
                    <div className="mt-8 w-full md:hidden lg:w-5/12">
                        <img
                            src={image}
                            alt={imageAlt}
                            title={imageTitle}
                            className="w-full h-auto"
                        />
                    </div>
                    <div
                        className={`w-full space-y-6 px-2 md:px-0 lg:w-6/12 md:pl-0 mx-auto lg:text-left ${alignmentClass}`}>
                        <div
                            className="w-36 text-white p-[2px] rounded-full olm-gradient"
                            rel="noreferrer"
                            href="/get-free-samples">
                            <span className="flex text-olh font-bold rounded-full bg-white p-1 px-4 justify-center">
                                Case Study:
                            </span>
                        </div>
                        <SectionHeading size={size}>
                            <p className="text-left">{title}</p>
                        </SectionHeading>
                        <p className="font-bold text-left">{client}</p>
                        <div className="text-xl text-left">
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: description,
                                }}
                            />
                        </div>
                    </div>
                    <div className="mt-8 w-full hidden md:block lg:w-5/12">
                        <img
                            src={image}
                            alt={imageAlt}
                            title={imageTitle}
                            className="w-full h-auto"
                        />
                    </div>
                </div>
            </ContainerWrapper>
        </div>
    )
}
